module.exports = __webpack_public_path__ + "f52f2d7c69959aebecf54d75cf51e37c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/icons/fonts/icons.svg
// module id = 1079
// module chunks = 0